import { useState, type FormEvent } from "react";
import { errorMessage } from "../api/cerberus";

// O envio de formulário de todas as páginas: limpa o erro, marca ocupado
// enquanto `action` roda e, se ela falhar, mostra a mensagem da API ou o
// `fallback` da página.
export function useSubmit(
  action: () => Promise<void>,
  fallback: string,
): { busy: boolean; error: string | null; onSubmit: (ev: FormEvent) => Promise<void> } {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(ev: FormEvent): Promise<void> {
    ev.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await action();
    } catch (e) {
      setError(errorMessage(e, fallback));
    } finally {
      setBusy(false);
    }
  }

  return { busy, error, onSubmit };
}
